
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnership-program/apply",
      function () {
        return require("private-next-pages/partnership-program/apply.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnership-program/apply"])
      });
    }
  